module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy40MTQiIGhlaWdodD0iMTMuNDE0IiB2aWV3Qm94PSIwIDAgMTMuNDE0IDEzLjQxNCI+DQogIDxwYXRoIGlkPSJVbmlvbl83MiIgZGF0YS1uYW1lPSJVbmlvbiA3MiIgZD0iTTYsNiwwLDEyLDYsNiwwLDAsNiw2bDYtNkw2LDZsNiw2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC43MDcgMC43MDcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMiIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-close.svg
// module id = O2tJ
// module chunks = 1